<div class="stepper">
  <div class="header" tabindex="0" (click)="toggleStepsDropdown()" (keydown.enter)="toggleStepsDropdown()">
    <div class="header-icon">
      @if (headerIcon()) {
        <pc-icon [icon]="headerIcon()" [size]="ComponentSizesEnum.Medium"> </pc-icon>
      }
    </div>
    <div class="current-step">
      {{ currentStepName }}
    </div>
    <pc-icon [icon]="icon" [size]="'xsmall'"></pc-icon>
    <div class="custom-element-wrapper">
      <ng-content select="[custom-element]"></ng-content>
    </div>
  </div>
  <div class="separator" [class.visible]="isOpen">
    <pc-separator></pc-separator>
  </div>

  <div class="steps-dropdown" [@expandCollapse]="isOpen ? 'expanded' : 'collapsed'">
    <div class="steps">
      @for (step of steps; track step.name; let i = $index; let last = $last) {
        <pc-step-view [isLastStep]="last" [step]="step" (click)="onStepClick(i)"></pc-step-view>
      }
    </div>
    @if (accessibilityStatementText) {
      <a
        class="accessibility-statement"
        tabindex="0"
        (click)="accessibilityStatementClick()"
        (keyup.enter)="accessibilityStatementClick()"
      >
        {{ accessibilityStatementText }}
      </a>
    }
    <div *ngIf="isOpen" class="close-icon-container">
      <button
        class="close-icon"
        aria-label="Close dropdown stepper"
        pcButton
        [color]="'primary'"
        [icon]="closeIcon"
        [size]="'xsmall'"
        (click)="toggleStepsDropdown()"
      ></button>
    </div>
  </div>
</div>
